import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "hooks/useQuery";

import { IUser } from "services/types";
import { useSearchCreatorsQuery } from "queries";
import { CreatorsFeed, FeedControl } from "components/creators";
import { TopicSelector } from "components/explore/TopicSelector";
import { routes } from "routes";

import "./ExploreCreatorsPage.scss";
import { ContentPageSkyscraperEnum } from "components/ads/config/units/contentPageSkyscraper";
import { WithSideAds } from "components/ads";

export const ExploreCreatorsPage = (): JSX.Element => {
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState<number>(1);
  const [users, setUsers] = useState<IUser[]>([]);
  const [order, setOrder] = useState<string>("trending");
  const [verified, setVerified] = useState<boolean>(false);
  const navigate = useNavigate();
  const query = useQuery();

  const { status, data } = useSearchCreatorsQuery({
    order: order,
    page: page,
    verified: verified,
  });

  useEffect(() => {
    document.title = "Top Creators | RedGIFs";
  }, []);

  useEffect(() => {
    if (status === "success") {
      setPage(data.page);
      setPages(data.pages);

      setUsers((prev) => {
        return [...prev, ...data.items];
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, data]);

  useEffect(() => {
    const orderParam = query.get("order");
    const verifiedParam = query.get("verified");

    if (orderParam) {
      changeOrder(orderParam);
    }

    if (verifiedParam) {
      changeVerified(!!verifiedParam);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeOrder = (value: string): void => {
    const verifiedParam = !!query.get("verified") || verified;

    navigate(routes.exploreCreators(value, verifiedParam));
    setOrder(value);
    setUsers([]);
  };

  const changeVerified = (value: boolean): void => {
    const orderParam = query.get("order") || order;
    navigate(routes.exploreCreators(orderParam, value));
    setVerified(value);
    setUsers([]);
  };

  const fetchMore = () => {
    setPage((prev) => prev + 1);
  };

  return (
    <Fragment>
      <WithSideAds
        leftAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperL1,
        ]}
        rightAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperR1,
        ]}
      >
        <div className="wide page creatorsPage">
          <TopicSelector active="creators" />

          <FeedControl
            order={order}
            verified={verified}
            changeOrder={changeOrder}
            changeVerified={changeVerified}
            isWithLatest
          />

          {status === "error" && <p>Error loading page.</p>}

          {status === "loading" && users.length === 0 && <p>Loading data...</p>}

          {users.length > 0 && <CreatorsFeed
            users={users}
            hasMore={page < pages}
            fetchMore={fetchMore}
          />}
        </div>
      </WithSideAds>
    </Fragment>
  );
};
